// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FashionInspiration-components-IFrameDialog-IFrameDialog-module-closeIconButton {
    margin-right: 16px;
}

.FashionInspiration-components-IFrameDialog-IFrameDialog-module-closeIcon {
    color: var(--WhiteTextColor);
}

.FashionInspiration-components-IFrameDialog-IFrameDialog-module-subTitle {
    margin-right: 0;
    position: relative;
}

.FashionInspiration-components-IFrameDialog-IFrameDialog-module-subTitle::after {
    background: white;
    bottom: 0;
    content:"";
    height: 100%;
    left: -8px;
    position: absolute;
    width: 1px;
}

.FashionInspiration-components-IFrameDialog-IFrameDialog-module-iFrame {
    border: none;
    -ms-flex: 1;
        flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/FashionInspiration/components/IFrameDialog/IFrameDialog.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAO;QAAP,OAAO;AACX","sourcesContent":[".closeIconButton {\n    margin-right: 16px;\n}\n\n.closeIcon {\n    color: var(--WhiteTextColor);\n}\n\n.subTitle {\n    margin-right: 0;\n    position: relative;\n}\n\n.subTitle::after {\n    background: white;\n    bottom: 0;\n    content:\"\";\n    height: 100%;\n    left: -8px;\n    position: absolute;\n    width: 1px;\n}\n\n.iFrame {\n    border: none;\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeIconButton": `FashionInspiration-components-IFrameDialog-IFrameDialog-module-closeIconButton`,
	"closeIcon": `FashionInspiration-components-IFrameDialog-IFrameDialog-module-closeIcon`,
	"subTitle": `FashionInspiration-components-IFrameDialog-IFrameDialog-module-subTitle`,
	"iFrame": `FashionInspiration-components-IFrameDialog-IFrameDialog-module-iFrame`
};
module.exports = ___CSS_LOADER_EXPORT___;
